import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DbModalService} from "../../../../../../../modules/modal/modal";
import {MediaLibraryComponent} from "../media-library/media-library.component";
import {DragulaService} from "ng2-dragula";
import {IMedia} from "../../../../ecommerce-product.interface";
import {ProductAddHelperService} from "../../product-add-helper.service";

@Component({
    selector: 'db-product-images',
    templateUrl: './product-images.component.html',
    styleUrl: './product-images.component.scss',
    standalone: false
})
export class ProductImagesComponent implements OnDestroy, OnInit {
  @Input() websiteId: number;
  @Input() mainImage: IMedia;
  @Input() secondaryImages: IMedia[] = [];
  @Input() selectedImages: number[] = [];

  constructor(private _modalService: DbModalService,
              private _productHelperService: ProductAddHelperService,
              private _dragulaService: DragulaService) {
    this._dragulaService.createGroup('PRODUCT_IMAGES', {
      revertOnSpill: true,
      direction: 'horizontal',
      // moves: (el, container, handle) => {
      //   return handle.classList.contains('image-handle');
      // }
    });
  }

  ngOnInit() {
    this._addImagesToService();
  }

  deleteSelectedImages() {
  this.secondaryImages = this.secondaryImages.filter(image => !this.selectedImages.includes(image.id));
    this._addImagesToService();
  }

  openMediaLib(forMain = false) {
    const modal = this._modalService.open(MediaLibraryComponent);
    modal.componentInstance.websiteId = this.websiteId;
    modal.componentInstance.forMain = forMain;
    modal.closed.subscribe((images: IMedia[]) => {
      if (forMain) {
        this.mainImage = images.at(0);
      } else {
        this.secondaryImages = [...this.secondaryImages, ...images];
      }

      this._addImagesToService();
    });
  }

  secondaryImagesOrderChanged(secondaryImages: any[]) {
    this.secondaryImages = secondaryImages;
    this._addImagesToService();
  }

  private _addImagesToService() {
    if (this.mainImage) {
      this._productHelperService.images = [this.mainImage, ...this.secondaryImages];
    } else {
      this._productHelperService.images = this.secondaryImages;
    }
  }

  selectImage(image) {
    if (this.selectedImages.includes(image.id)) {
      this.selectedImages = this.selectedImages.filter(img => img !== image.id);
      return;
    }
    this.selectedImages.push(image.id);
  }

  removeImage(image: any, mainImage = false) {
    if (mainImage) {
      this.mainImage = null;
      return;
    }
    this.secondaryImages = this.secondaryImages.filter(img => img.source_url !== image.source_url);
    this._addImagesToService();
  }

  ngOnDestroy() {
    this._dragulaService.destroy('PRODUCT_IMAGES');
    this._addImagesToService();
  }
}
